import { RequestService } from '../RequestService'
import { useEnvStore } from 'store'

export class UserRebate extends RequestService {
  constructor() {
    super()
  }

  protected setBaseUrl(): string {
    const envStore = useEnvStore()
    return envStore.config?.appuc || ''
  }

  // 获取邀请好友信息
  getTotalRebateStats(data: { rebateTypeList: string; ctime: string; etime: string; page: number; page_size: number }) {
    return this.post<ApiResponse.TotalRebateStats>('/V3/UserRebate/getTotalRebateStats', data)
  }

  // 获取推广中心上面的展示信息
  getRebateCommonInfo() {
    return this.post<ApiResponse.PromotionCenterData>('/V3/UserRebate/getRebateCommonInfo')
  }

  // 推广中心-邀请码列表
  getInviteCodeStats(data: { page: number; pageSize: number }) {
    return this.post<ApiResponse.InviteCodeListResponse>('/V3/UserRebate/getInviteCodeStats', data)
  }

  // 推广中心-修改邀请码名称
  updateInviteCodeName(data: { note?: string; inviteCode: string; isDefault?: 1 | 2 }) {
    return this.post('/V3/UserRebate/updateInviteCode', data)
  }
}

export const UserRebateServices = new UserRebate()
